<template>
  <b-card bg-variant="none">
      <ams-table
        :heading="heading"
        :ams_api_path="ams_api_path"
        :ams_type="ams_type"
        :ams_fields="ams_fields"
        :describe_belongs_to="describe_belongs_to"
        :filtering="filtering"
        :refresh="refresh"
        :refreshed="doRefresh"
        :reroute_name="reroute_name"
        :ams_template="ams_template"
      />
  </b-card>
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable,
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      heading: 'Product Listing',
      ams_type: 'product-listings',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'ProductListingCreateScreen',
      ams_fields: [
       { 
          key: 'attributes.edition',
          label: 'Edition',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc' 
        },
        {
          key: 'attributes.price-cents',
          label: 'Price',
          sortable: true,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc',
          formatter: value => {
              return '$' + (value / 100).toFixed(2)
          }
        },
       { 
          key: 'attributes.description',
          label: 'Description',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },

      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'brands',
          description_attr: 'name',
          append: ': '
        },
        {
          prepend: '',
          type: 'product-models',
          description_attr: 'name',
          append: ''
        }
      ]
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>